import { TaskType } from 'api-validations/ag-concepts'
import { ApplicationType } from 'api-validations/stitch'
import type React from 'react'

import { SpriteMap } from '../global'
import { Icon } from './Icon'
import { taskColors } from './variants'

export const taskIconSprites: Record<TaskType, SpriteMap> = {
  [TaskType.Plant]: SpriteMap.PlanterIcon,
  [TaskType.Sidedress]: SpriteMap.SidedressIcon,
  [TaskType.Spray]: SpriteMap.SprayerIcon,
  [TaskType.Striptill]: SpriteMap.StripTillIcon,
  [TaskType.Harvest]: SpriteMap.HarvestIcon
}

/**
 * The icon for each kind of application, where one exists. Implement and global applications have
 * none of their own.
 */
export const applicationIconSprites: Record<ApplicationType, SpriteMap | null> = {
  [ApplicationType.Granular]: SpriteMap.GranularIcon,
  [ApplicationType.Seeding]: SpriteMap.HybridIcon,
  [ApplicationType.Liquid]: SpriteMap.LiquidIcon,
  [ApplicationType.Force]: SpriteMap.ForceIcon,
  [ApplicationType.LinearPosition]: SpriteMap.LinearPositionIcon,
  [ApplicationType.Pressure]: SpriteMap.PressureIcon,
  [ApplicationType.Harvest]: SpriteMap.HarvestIcon,
  [ApplicationType.Implement]: null,
  [ApplicationType.Global]: null
}

export const applicationIconSprite = ({
  applicationType,
  task
}: {
  applicationType: ApplicationType
  task: TaskType
}): SpriteMap => applicationIconSprites[applicationType] ?? taskIconSprites[task]

/**
 * Renders a task icon for the given task type with its default task color.
 */
export const TaskIcon: React.FC<{ task: TaskType; className?: string }> = ({ task, className }) => {
  const sprite = taskIconSprites[task]
  return <Icon icon={sprite} className={taskColors({ text: task, class: className })} />
}
